import { SmartagentContext } from "contexts/SmartagentContext"
import { useContext } from "react"

export const useSmartagent = () => {
    const smartagent = useContext(SmartagentContext);
    return smartagent
}